import styled from 'styled-components';

/**
 * Carries a `data-cy` hook into the DOM for a design-system layout component that does not render one.
 * `FlexColumn` accepts `data-cy` and drops it (unlike `FlexRow`, which renders it), so a hook set on a
 * `styled(FlexColumn)` never reaches a real browser. Wrapping the column in this element puts the
 * attribute in the DOM while `display: contents` makes the element generate no box of its own, so the
 * column stays its parent's flex item and all layout remains the design system's.
 *
 * Because it has no box, it has no size: assert on it with `exist` rather than `be.visible`.
 */
export const TestHook = styled.div`
	display: contents;
`;
